<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>
      {{ 'Gerenciar Solicitações Administrativas' | translate }}</ion-title
    >
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-row class="filter">
    <ion-col>
      <ion-button
        id="filtrar"
        (click)="filtrar()"
        shape="round"
        fill="outline"
        size="small"
        color="medium"
        class="button-filter"
      >
        {{'Filtrar' | translate}}
      </ion-button>
    </ion-col>
  </ion-row>

  <div class="header-padding">
    <div class="top-border">
      <ion-list *ngIf="solicitacoes">
        <ion-card *ngFor="let solicitacao of solicitacoes">
          <ion-item-sliding
              [ngClass]="{
                'border-color': solicitacao.status != 'Finalizado'
              }"
          >
            <ion-item (click)="openOption()" lines="none">
              <ion-grid>
                <ion-row>
                  <ion-col size="auto">
                    <ion-avatar>
                      <img [src]="solicitacao.foto | image: ''" />
                    </ion-avatar>
                  </ion-col>

                  <ion-col>
                    <h4 class="ellipse nome">{{ solicitacao.nome }}</h4>
                  </ion-col>
                </ion-row>

                <ion-item-divider></ion-item-divider>

                <ion-row>
                  <ion-col size="12">
                    <p class="color-title">
                      {{ 'DETALHES DA SOLICITAÇÃO:' | translate }}
                    </p>
                  </ion-col>

                  <ion-col size="12">
                    <span class="descricoes">
                      {{'Data da Solicitação' | translate}}: {{ solicitacao.data | date:'dd/MM' }}
                      às {{ solicitacao.data | date:'HH:mm' }}
                    </span>
                  </ion-col>

                  <ion-col size="12">
                    <span class="descricoes">
                      {{'Origem' | translate}}: {{ solicitacao.formaPedido }}
                    </span>
                  </ion-col>

                  <ion-col size="12">
                    <span class="descricoes">{{'Status' | translate}}:</span>

                    <span
                      class="badge"
                      [ngClass]="{
                        pendente: solicitacao.status == 'Pendente',
                        andamento: solicitacao.status == 'Andamento',
                        finalizado: solicitacao.status == 'Finalizado'
                      }"
                    >
                      {{ solicitacao.status }}
                    </span>
                  </ion-col>

                  <ion-col size="12">
                    <span class="descricoes">
                      {{'Tipo' | translate}}: {{ solicitacao.tipo }}
                    </span>
                  </ion-col>

                  <ion-col size="12">
                    <h5 class="descricoes-pedido">{{ solicitacao.pedido }}</h5>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-item>

            <ion-item-options
              side="end"
              *ngIf="solicitacao.status != 'Finalizado'"
            >
              <ion-item-option
                color="danger"
                (click)="anotacao(solicitacao.idSolicitacao)"
              >
                {{ 'Finalizar' | translate }}
              </ion-item-option>

              <ion-item-option (click)="adicionar(solicitacao)" *ngIf="solicitacao.tipo !=  'Desligamento'">
                {{ 'Adicionar' | translate }}
              </ion-item-option>
            </ion-item-options>
          </ion-item-sliding>
        </ion-card>
      </ion-list>

      <div *ngIf="solicitacoesVazias">
        <ion-grid>
          <ion-row>
            <ion-col>
              <ion-list>
                <sem-registro
                  [text]="'Nenhuma solicitação pendente'"
                ></sem-registro>
              </ion-list>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>
</ion-content>
